// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6d174473","879":"32be0a95"}[chunkId] + ".chunk.js";
};